export default "__VITE_ASSET__DAL4bEjK__"